import React, { useEffect, useState } from "react"
import { Helmet } from "react-helmet"

import Config from "../../api/Config"
import { AUTH } from "../../api/Registry"
import HttpServices from "../../services/HttpServices"
import { GoogleLogin, GoogleOAuthProvider } from '@react-oauth/google';



export const Home = () => {
    const clientId = "73867460659-5tqlbkf47dmfeojsk8gc5c0hoicvg8bu.apps.googleusercontent.com";

    const [loginUrl, setLoginUrl] = useState(null);

    useEffect(() => {
        googleAuthSignIn()
    }, []);


    const googleAuthSignIn = async () => {
        try {
            const response: any = await HttpServices.httpGet('/api/v1/identity/auth/google/redirect');

            console.log('REsponse=====', response);

            if (response.status === 200) {
                setLoginUrl(response.data.url)
                // toast.success(`Default authentication provider changed to ${provider.e}`);
            } else {
                // toast.error(APPLICATION.ERR_MSG);
            }
        } catch (error) {
            console.error(error)
        }
    }

    return (
        <React.Fragment>
            <Helmet>
                <title>{Config.APP_NAME} Home</title>
            </Helmet>

            <div className="flex items-center justify-center h-full bg-theme from-[#ffffff] via-[#ffffff] via-[40%] to-gradient">
                <h1 className={`text-primary`}>
                    Welcome  Home


                    <div>
                        {loginUrl != null && (
                            <a href={loginUrl}>Google Sign In</a>
                        )}
                    </div>
                </h1>



            </div>
        </React.Fragment>
    )
}